export default __webpack_public_path__ + "static/media/user-placeholder.e98dce99.svg";